<template>
     <div class="navbar-back">
      <div class="btn" @click="goBack()">
        <svg t="1763602383997" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3707" width="32" height="32"><path d="M1024 448H245.184L602.88 90.24 512 0 0 512l512 512 90.24-90.24L245.184 576H1024z" fill="#333333" p-id="3708"></path></svg>
      </div>
    </div>
</template>
<script>
export default {
  name: 'xmlNavBack',
  data() {
    return {
      
    }
  },
  methods: {
    goBack() {
      window.history.back(); 
    }
  }
}
</script>
<style scoped lang="scss">

.navbar-back{
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 40px;
  padding: 0  16px;
//   background-color: #fff;
  .btn{
    width: 20px;
    cursor: pointer;
    svg{
      width: 100%;
    }
  }
}
</style>